import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-editor-view',
  templateUrl: './editor-view.component.html',
  styleUrls: ['./editor-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditorViewComponent {
  @Input() value?: string;
}
